import styles from "./ThirdScreen.module.css"
import { useEffect } from "react"
import ScrollReveal from "scrollreveal"
import ring1 from "../images/בטי קנפו טבעות 1.png"
import ring2 from "../images/בטי קנפו טבעות 2.png"
import ring3 from "../images/בטי קנפו טבעות 3.png"
import ring4 from "../images/בטי קנפו טבעות 4.png"
import ring5 from "../images/בטי קנפו טבעות 5.png"
import ring6 from "../images/בטי קנפו טבעות 6.png"
import ring7 from "../images/בטי קנפו טבעות 7.png"
import ring8 from "../images/בטי קנפו טבעות 8.png"
import ring9 from "../images/בטי קנפו טבעות 9.png"
import ring10 from "../images/בטי קנפו טבעות 10.png"
import ring11 from "../images/בטי קנפו טבעות 11.png"
import ring12 from "../images/בטי קנפו טבעות 12.png"
import ring13 from "../images/בטי קנפו טבעות 13.png"
import ring14 from "../images/בטי קנפו טבעות 14.png"
import ring15 from "../images/בטי קנפו טבעות 15.png"
import ring16 from "../images/בטי קנפו טבעות 16.png"
import ring17 from "../images/בטי קנפו טבעות 17.png"
import ring18 from "../images/בטי קנפו טבעות 18.png"
import ring19 from "../images/בטי קנפו טבעות 19.png"
import ring20 from "../images/בטי קנפו טבעות 20.png"
import ring21 from "../images/בטי קנפו טבעות 21.png"
import ring22 from "../images/בטי קנפו טבעות 22.png"
import ring23 from "../images/בטי קנפו טבעות 23.png"
import ring24 from "../images/בטי קנפו טבעות 24.png"
import ring25 from "../images/בטי קנפו טבעות 25.png"
import ring26 from "../images/בטי קנפו טבעות 26.png"
import ring27 from "../images/בטי קנפו טבעות 27.png"
import ring28 from "../images/בטי קנפו טבעות 28.png"
import ring29 from "../images/בטי קנפו טבעות 29.png"
import ring30 from "../images/בטי קנפו טבעות 30.png"
import ring31 from "../images/בטי קנפו טבעות 31.png"
import ring32 from "../images/בטי קנפו טבעות 32.png"
import ring33 from "../images/בטי קנפו טבעות 33.png"
import ring34 from "../images/בטי קנפו טבעות 34.png"
import ring35 from "../images/בטי קנפו טבעות 35.png"
import ring36 from "../images/בטי קנפו טבעות 36.png"
import ring37 from "../images/בטי קנפו טבעות 37.png"
import ring38 from "../images/בטי קנפו טבעות 38.png"
import ring39 from "../images/בטי קנפו טבעות 39.png"
import ring40 from "../images/בטי קנפו טבעות 40.png"



import necklace1 from "../images/בטי קנפו שרשראות 1.png"
import necklace2 from "../images/בטי קנפו שרשראות 2.png"
import necklace3 from "../images/בטי קנפו שרשראות 3.png"
import necklace4 from "../images/בטי קנפו שרשראות 4.png"
import necklace5 from "../images/בטי קנפו שרשראות 5.png"
import necklace6 from "../images/בטי קנפו שרשראות 6.png"
import necklace7 from "../images/בטי קנפו שרשראות 7.png"
import necklace8 from "../images/בטי קנפו שרשראות 8.png"
import necklace9 from "../images/בטי קנפו שרשראות 9.png"
import necklace10 from "../images/בטי קנפו שרשראות 10.png"
import necklace11 from "../images/בטי קנפו שרשראות 11.png"
import necklace12 from "../images/בטי קנפו שרשראות 12.png"
import necklace13 from "../images/בטי קנפו שרשראות 13.png"
import necklace14 from "../images/בטי קנפו שרשראות 14.png"
import necklace15 from "../images/בטי קנפו שרשראות 15.png"
import necklace16 from "../images/בטי קנפו שרשראות 16.png"
import necklace17 from "../images/בטי קנפו שרשראות 17.png"
import necklace18 from "../images/בטי קנפו שרשראות 18.png"
import necklace19 from "../images/בטי קנפו שרשראות 19.png"
import necklace20 from "../images/בטי קנפו שרשראות 20.png"
import necklace21 from "../images/בטי קנפו שרשראות 21.png"
import necklace22 from "../images/בטי קנפו שרשראות 22.png"
import necklace23 from "../images/בטי קנפו שרשראות 23.png"
import necklace24 from "../images/בטי קנפו שרשראות 24.png"
import necklace25 from "../images/בטי קנפו שרשראות 25.png"
import necklace26 from "../images/בטי קנפו שרשראות 26.png"
import necklace27 from "../images/בטי קנפו שרשראות 27.png"
import necklace28 from "../images/בטי קנפו שרשראות 28.png"
import necklace29 from "../images/בטי קנפו שרשראות 29.png"
import necklace30 from "../images/בטי קנפו שרשראות 30.png"
import necklace31 from "../images/בטי קנפו שרשראות 31.png"
import necklace32 from "../images/בטי קנפו שרשראות 32.png"
import necklace33 from "../images/בטי קנפו שרשראות 33.png"
import necklace34 from "../images/בטי קנפו שרשראות 34.png"
import necklace35 from "../images/בטי קנפו שרשראות 35.png"
import necklace36 from "../images/בטי קנפו שרשראות 36.png"
import sharsheraot from "../images/בטי שרשאות ראשית.png"



import earring1 from "../images/בטי קנפו עגילים 1.png"
import earring2 from "../images/בטי קנפו עגילים 2.png"
import earring3 from "../images/בטי קנפו עגילים 3.png"
import earring4 from "../images/בטי קנפו עגילים 4.png"
import earring5 from "../images/בטי קנפו עגילים 5.png"
import earring6 from "../images/בטי קנפו עגילים 6.png"
import earring7 from "../images/בטי קנפו עגילים 7.png"
import earring8 from "../images/בטי קנפו עגילים 8.png"
import earring9 from "../images/בטי קנפו עגילים 9.png"
import earring10 from "../images/בטי קנפו עגילים 10.png"
import earring11 from "../images/בטי קנפו עגילים 11.png"
import earring12 from "../images/בטי קנפו עגילים 12.png"
import earring13 from "../images/בטי קנפו עגילים 13.png"
import earring14 from "../images/בטי קנפו עגילים 14.png"
import earring15 from "../images/בטי קנפו עגילים 15.png"
import earring16 from "../images/בטי קנפו עגילים 16.png"
import earring17 from "../images/בטי קנפו עגילים 17.png"
import earring18 from "../images/בטי קנפו עגילים 18.png"
import earring19 from "../images/בטי קנפו עגילים 19.png"
import earring20 from "../images/בטי קנפו עגילים 20.png"
import earring21 from "../images/בטי קנפו עגילים 21.png"
import earring22 from "../images/בטי קנפו עגילים 22.png"
import earring23 from "../images/בטי קנפו עגילים 23.png"
import earring24 from "../images/בטי קנפו עגילים 24.png"
import earring25 from "../images/בטי קנפו עגילים 25.png"
import earring26 from "../images/בטי קנפו עגילים 26.png"
import earring27 from "../images/בטי קנפו עגילים 27.png"
import earring28 from "../images/בטי קנפו עגילים 28.png"
import earring29 from "../images/בטי קנפו עגילים 29.png"
import earring30 from "../images/בטי קנפו עגילים 30.png"
import earring31 from "../images/בטי קנפו עגילים 31.png"
import earring32 from "../images/בטי קנפו עגילים 32.png"
import earring33 from "../images/בטי קנפו עגילים 33.png"
import earring34 from "../images/בטי קנפו עגילים 34.png"
import earring35 from "../images/בטי קנפו עגילים 35.png"
import earring36 from "../images/בטי קנפו עגילים 36.png"
import earring37 from "../images/בטי קנפו עגילים 37.png"
import earring38 from "../images/בטי קנפו עגילים 38.png"
import earring39 from "../images/בטי קנפו עגילים 39.png"
import earring40 from "../images/בטי קנפו עגילים 40.png"
import earring41 from "../images/בטי קנפו עגילים 41.png"
import earring42 from "../images/בטי קנפו עגילים 42.png"
import earring43 from "../images/בטי קנפו עגילים 43.png"
import earring44 from "../images/בטי קנפו עגילים 44.png"
import earring45 from "../images/בטי קנפו עגילים 45.png"
import earring46 from "../images/בטי קנפו עגילים 46.png"
import earring47 from "../images/בטי קנפו עגילים 47.png"
import earring48 from "../images/בטי קנפו עגילים 48.png"
import earring49 from "../images/בטי קנפו עגילים 49.png"
import earring50 from "../images/בטי קנפו עגילים 50.png"
import earring51 from "../images/בטי קנפו עגילים 51.png"
import earring52 from "../images/בטי קנפו עגילים 52.png"
import earring53 from "../images/בטי קנפו עגילים 53.png"
import earring54 from "../images/בטי קנפו עגילים 54.png"
import earring55 from "../images/בטי קנפו עגילים 55.png"
import earring56 from "../images/בטי קנפו עגילים 56.png"
import earring57 from "../images/בטי קנפו עגילים 57.png"
import earring58 from "../images/בטי קנפו עגילים 58.png"
import earring59 from "../images/בטי קנפו עגילים 59.png"
import earring60 from "../images/בטי קנפו עגילים 60.png"
import earring61 from "../images/בטי קנפו עגילים 61.png"
import earring62 from "../images/בטי קנפו עגילים 62.png"
import earring63 from "../images/בטי קנפו עגילים 63.png"
import earring64 from "../images/בטי קנפו עגילים 64.png"
import earring65 from "../images/בטי קנפו עגילים 65.png"
import earring66 from "../images/בטי קנפו עגילים 66.png"
import earring67 from "../images/בטי קנפו עגילים 67.png"
import earring68 from "../images/בטי קנפו עגילים 68.png"
import earring69 from "../images/בטי קנפו עגילים 69.png"
import earring70 from "../images/בטי קנפו עגילים 70.png"
import earring71 from "../images/בטי קנפו עגילים 71.png"
import earring72 from "../images/בטי קנפו עגילים 72.png"
import earring73 from "../images/בטי קנפו עגילים 73.png"
import earring74 from "../images/בטי קנפו עגילים 74.png"
import earring75 from "../images/בטי קנפו עגילים 75.png"
import earring76 from "../images/בטי קנפו עגילים 76.png"
import earring77 from "../images/בטי קנפו עגילים 77.png"
import earring78 from "../images/בטי קנפו עגילים 78.png"
import earring79 from "../images/בטי קנפו עגילים 79.png"
import earring80 from "../images/בטי קנפו עגילים 80.png"
import earring81 from "../images/בטי קנפו עגילים 81.png"
import earring82 from "../images/בטי קנפו עגילים 82.png"
import earring83 from "../images/בטי קנפו עגילים 83.png"
import earring84 from "../images/בטי קנפו עגילים 84.png"
import earring85 from "../images/בטי קנפו עגילים 85.png"
import earring86 from "../images/בטי קנפו עגילים 86.png"
import earring87 from "../images/בטי קנפו עגילים 87.png"
import earring88 from "../images/בטי קנפו עגילים 88.png"
import earring89 from "../images/בטי קנפו עגילים 89.png"
import agilim from "../images/בטי עגילים ראשית.png"


import bracelet1 from "../images/בטי קנפו צמידים 1.png"
import bracelet2 from "../images/בטי קנפו צמידים 2.png"
import bracelet3 from "../images/בטי קנפו צמידים 3.png"
import bracelet4 from "../images/בטי קנפו צמידים 4.png"
import bracelet5 from "../images/בטי קנפו צמידים 5.png"
import bracelet6 from "../images/בטי קנפו צמידים 6.png"
import bracelet7 from "../images/בטי קנפו צמידים 7.png"
import bracelet8 from "../images/בטי קנפו צמידים 8.png"
import bracelet9 from "../images/בטי קנפו צמידים 9.png"
import bracelet10 from "../images/בטי קנפו צמידים 10.png"
import bracelet11 from "../images/בטי קנפו צמידים 11.png"

import course1 from "../images/בטי קנפו תמונה עם תלמידה 1.png"
import course2 from "../images/בטי קנפו תמונה עם תלמידה 2.png"
import course3 from "../images/בטי קנפו תמונה עם תלמידה 3.png"
import course4 from "../images/בטי קנפו תמונה עם תלמידה 4.png"

import riss1 from "../images/בטי קנפו ריסים 1.png"
import riss2 from "../images/בטי קנפו ריסים 2.png"
import riss3 from "../images/בטי קנפו ריסים 3.png"
import riss4 from "../images/בטי קנפו ריסים 4.png"
import riss5 from "../images/בטי קנפו ריסים 5.png"
import riss6 from "../images/בטי קנפו ריסים 6.png"
import riss7 from "../images/בטי קנפו ריסים 7.png"
import riss8 from "../images/בטי קנפו ריסים 8.png"
import riss9 from "../images/בטי קנפו ריסים 9.png"

import eyebrows1 from "../images/בטי קנפו עיצוב גבות 1.png"
import eyebrows2 from "../images/בטי קנפו עיצוב גבות 2.png"
import eyebrows3 from "../images/בטי קנפו עיצוב גבות 3.png"
import eyebrows4 from "../images/בטי קנפו עיצוב גבות 4.png"
import eyebrows5 from "../images/בטי קנפו עיצוב גבות 5.png"
import eyebrows6 from "../images/בטי קנפו עיצוב גבות 6.png"
import eyebrows7 from "../images/בטי קנפו עיצוב גבות 7.png"
import eyebrows8 from "../images/בטי קנפו עיצוב גבות 8.png"
import eyebrows9 from "../images/בטי קנפו עיצוב גבות 9.png"

import tan1 from "../images/בטי קנפו שיזוף בהתזה 1.png"
import tan2 from "../images/בטי קנפו שיזוף בהתזה 2.png"
import tan3 from "../images/בטי קנפו שיזוף בהתזה 3.png"
import tan4 from "../images/בטי קנפו שיזוף בהתזה 4.png"
import tan5 from "../images/בטי קנפו שיזוף בהתזה 5.png"
import tan6 from "../images/בטי קנפו שיזוף בהתזה 6.png"
import tan7 from "../images/בטי קנפו שיזוף בהתזה 7.png"
import tan8 from "../images/בטי קנפו שיזוף בהתזה 8.png"

import makeup1 from "../images/בטי קנפו איפור 1.png"
import makeup2 from "../images/בטי קנפו איפור 2.png"
import makeup3 from "../images/בטי קנפו איפור 3.png"
import makeup4 from "../images/בטי קנפו איפור 4.png"
import makeup5 from "../images/בטי קנפו איפור 5.png"
import makeup6 from "../images/בטי קנפו איפור 6.png"
import makeup7 from "../images/בטי קנפו איפור 7.png"
import makeup8 from "../images/בטי קנפו איפור 8.png"
import makeup9 from "../images/בטי קנפו איפור 9.png"
import makeup10 from "../images/בטי קנפו איפור 10.png"

import permanentMakeup1 from "../images/בטי קנפו איפור קבוע 1.png"
import permanentMakeup2 from "../images/בטי קנפו איפור קבוע 2.png"
import permanentMakeup3 from "../images/בטי קנפו איפור קבוע 3.png"
import permanentMakeup4 from "../images/בטי קנפו איפור קבוע 4.png"
import permanentMakeup5 from "../images/בטי קנפו איפור קבוע 5.png"
import permanentMakeup6 from "../images/בטי קנפו איפור קבוע 6.png"
import permanentMakeup7 from "../images/בטי קנפו איפור קבוע 7.png"
import permanentMakeup8 from "../images/בטי קנפו איפור קבוע 8.png"
import permanentMakeup9 from "../images/בטי קנפו איפור קבוע 9.png"
import permanentMakeup10 from "../images/בטי קנפו איפור קבוע 10.png"
import permanentMakeup11 from "../images/בטי קנפו איפור קבוע 11.png"
import permanentMakeup12 from "../images/בטי קנפו איפור קבוע 12.png"
import permanentMakeup13 from "../images/בטי קנפו איפור קבוע 13.png"
import permanentMakeup14 from "../images/בטי קנפו איפור קבוע 14.png"
import permanentMakeup15 from "../images/בטי קנפו איפור קבוע 15.png"
import permanentMakeup16 from "../images/בטי קנפו איפור קבוע 16.png"
import permanentMakeup17 from "../images/בטי קנפו איפור קבוע 17.png"

import InfiniteCarousel from "../components/Carousel/Carousel"
import InfiniteCarouselR from "../components/Carousel/NewC"
import GalleryWithOverlay from "../components/Carousel/Carousel"
import Button from "../components/button/Button"
import ServicesGrid from "./SecondScreen"

const ThirdScreen = () => {
  useEffect(() => {
    ScrollReveal().reveal(`.${styles.title}`, {
      origin: 'top',
      distance: '50px',
      duration: 1000,
      delay: 200,
      easing: 'ease-in-out',
      reset: false,
      interval: 200
    })
  }, [])

  // הגדרת קטגוריות הטבעות
  const ringsCategories = [
    {
      id: 'regular',
      name: 'טבעות',
      images: [ring1, ring2, ring3, ring4, ring5, ring8, ring9, ring10, ring11, ring12, ring13, ring14, ring15, ring16 ,ring26, ring27, ring28, ring29, ring30, ring31, ring32, ring33, ring34, ring35, ring36, ring37, ring38, ring39, ring40],
      message: 'היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על טבעות 💍'
    },
    {
      id: 'zeret',
      name: 'טבעות זרת',
      images: [ring17, ring18, ring19, ring20, ring21, ring22, ring23, ring24, ring25],
      message: 'היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על טבעות זרת 💍✨'
    }
  ];

  // הגדרת קטגוריות העגילים
  const earringsCategories = [
    {
      id: 'studs',
      name: 'עגילים צמודים',
      images: [earring1, earring2,  earring79, earring80, earring85, earring86, earring87, earring82, earring83, earring84,earring81,earring3,earring78, earring4, earring6, earring7, earring9,   earring47, earring48, earring49, earring53, earring54, earring50, earring51, earring52,earring10],
      message: 'היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על עגילים צמודים 💎'
    },
    {
      id: 'hoops',
      name: 'עגילים נופלים',
      images: [earring12, earring13, earring14,earring70, earring15,earring45, earring16, earring17, earring18,earring56, earring57,earring58,earring24, earring25, earring26, earring27, earring28, earring29, earring30, earring31, earring32, earring33, earring34, earring35, earring36,  earring38, earring39,   earring63, earring64, earring65, earring66,  earring73, earring74, earring75, earring19,earring43, earring44, ],
      message: 'היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על עגילים נופלים ✨'
    },
    {
      id: 'drop',
      name: 'עגיל ללא חור',
      images: [ earring22, earring23,earring41, earring42],
      message: 'היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על עגילים ללא חור 👂'
    },
    {
      id: 'chain',
      name: 'עגילי שרשרת',
      images: [  earring62,earring37,earring67, earring71, earring72, earring55,  earring68, earring69, earring40,  earring59, earring60,earring20,earring46,earring61,earring21  ,earring88, earring89,],
      message: 'היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על עגילי שרשרת ⛓️'
    },
    {
      id: 'special',
      name: 'עיצובים מיוחדים',
      images: [  earring76, earring77, ],
      message: 'היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על עיצובים מיוחדים של עגילים 🌟'
    }
  ];

  // הגדרת קטגוריות איפור קבוע
  const permanentMakeupCategories = [
    {
      id: 'lips',
      name: 'פיגמנט שפתיים',
      images: [permanentMakeup1, permanentMakeup2, permanentMakeup4, permanentMakeup11,permanentMakeup12, permanentMakeup13, permanentMakeup14, permanentMakeup16, permanentMakeup17],
      message: 'היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על פיגמנט שפתיים 💋'
    },
    {
      id: 'microblading',
      name: 'מיקרובליידינג',
      images: [permanentMakeup10, permanentMakeup3,],
      message: 'היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על מיקרובליידינג 🖌️'
    },
    {
      id: 'powder',
      name: 'שיטת הפודרה',
      images: [permanentMakeup7, permanentMakeup9,],
      message: 'היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על שיטת הפודרה ✨'
    }
  ];

  return (
    <>
      <div className={styles.header}>קולקציית התכשיטים ב-BK</div>

      <div className={styles.row}>
        <div>
          <div id="rings" className={styles.title}>טבעות</div>
          <GalleryWithOverlay 
            images={[ring1]}
            categories={ringsCategories}
            categoryTitle="קולקציית הטבעות"
            serviceName="טבעות"
            defaultMessage="היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על טבעות 💍"
          />
        </div>

        <div>
          <div id="chains" className={styles.title}>שרשראות</div>
          <InfiniteCarouselR 
            images={[
              sharsheraot,necklace1, necklace2, necklace3, necklace4, necklace5, necklace6,
              necklace7, necklace8,  necklace11,necklace24, ,
              necklace13, necklace14, necklace15, necklace16, necklace17, necklace18,
              necklace19, necklace20, necklace21, necklace22, necklace23, necklace12,
              necklace25, necklace26, necklace27, necklace28, necklace29, necklace30,
              necklace31, necklace32, necklace33, necklace34, necklace35, necklace36,necklace10,
            ]}
            defaultMessage="היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על שרשראות ✨"
          />
        </div>
      </div>

      <div className={styles.row}>
        <div>
          <div id="bracelets" className={styles.title}>צמידים</div>
          <InfiniteCarousel 
            images={[bracelet1, bracelet2, bracelet3, bracelet4, bracelet5, bracelet6, bracelet7, bracelet8,]}
            defaultMessage="היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על צמידים 💫"
          />
        </div>

        <div>
          <div id="earrings" className={styles.title}>עגילים</div>
          <GalleryWithOverlay 
            images={[agilim]}
            categories={earringsCategories}
            categoryTitle="קולקציית העגילים"
            serviceName="עגילים"
            defaultMessage="היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על עגילים 💎"
          />
        </div>
      </div>

      <div className={styles.header}>טיפולי היופי ב-BK</div>

      <div className={styles.row}>
        <div>
          <div id="eyebrows" className={styles.title}>עיצוב גבות</div>
          <InfiniteCarousel 
            images={[eyebrows1, eyebrows2, eyebrows3, eyebrows4, eyebrows5, eyebrows6, eyebrows7, eyebrows8, eyebrows9]}
            defaultMessage="היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על עיצוב גבות ✨"
          />
        </div>

        <div>
          <div id="lashes" className={styles.title}>הדבקת ריסים</div>
          <InfiniteCarouselR 
            images={[riss1, riss2, riss3, riss4, riss5, riss6, riss7, riss8, riss9]}
            defaultMessage="היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על הדבקת ריסים 👁️"
          />
        </div>
      </div>

      <div className={styles.row}>
        <div>
          <div id="makeup" className={styles.title}>איפור - כלות וערב</div>
          <InfiniteCarousel 
            images={[makeup1, makeup2, makeup3, makeup4, makeup5, makeup6, makeup7, makeup8, makeup9, makeup10]}
            defaultMessage="היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על איפור כלות וערב 💄"
          />
        </div>

        <div>
          <div id="permanent-makeup" className={styles.title}>איפור קבוע</div>
          <GalleryWithOverlay 
            images={[permanentMakeup1]}
            categories={permanentMakeupCategories}
            categoryTitle="קולקציית האיפור הקבוע"
            serviceName="איפור קבוע"
            defaultMessage="היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על איפור קבוע 💋"
          />
        </div>

        <div>
          <div id="spray-tan" className={styles.title}>שיזוף במכונה</div>
          <InfiniteCarousel 
            images={[tan1, tan2, tan3, tan4, tan5, tan6, tan7, tan8]}
            defaultMessage="היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד על שיזוף במכונה ☀️"
          />
        </div>
      </div>
    </>
  )
}

export default ThirdScreen